import { Controller } from "@hotwired/stimulus";

// Alert with an optional collapsible details section and a dismiss button.
export default class extends Controller {
  static targets = ["details", "toggleBtn", "toggleLabel"];

  declare readonly hasDetailsTarget: boolean;
  declare readonly detailsTarget: HTMLElement;
  declare readonly hasToggleBtnTarget: boolean;
  declare readonly toggleBtnTarget: HTMLButtonElement;
  declare readonly hasToggleLabelTarget: boolean;
  declare readonly toggleLabelTarget: HTMLElement;

  toggleDetails() {
    const expanded = this.toggleBtnTarget.getAttribute("aria-expanded") === "true";

    this.detailsTarget.classList.toggle("alert__details--expanded", !expanded);
    this.toggleBtnTarget.setAttribute("aria-expanded", String(!expanded));

    if (this.hasToggleLabelTarget) {
      this.toggleLabelTarget.textContent = expanded ? "View details" : "Hide details";
    }
  }

  dismiss() {
    this.element.remove();
  }
}
